type Platform =
  | "facebook"
  | "instagram"
  | "pinterest"
  | "threads"
  | "reddit"
  | "tiktok"
  | "telegram"
  | "web"
  | "coupon"
  | "blog"
  | "share"
  | "email"
  | "x"
  | "twitter"
  | "youtube"
  | "discord"
  | "twitch"
  | "linkedin"
  | "github"
  | "website"
  | "podcast"
  | "secret code"
  | "bonus entries"
  | "viral share"
  | "bookings / reservations"
  | "custom"
  | "promo amp"
  | "app store"
  | "google play"

const PLATFORM_ICONS: Record<string, string> = {
  facebook: "https://img.promoamp.com/icons/white/facebook.svg",
  instagram: "https://img.promoamp.com/icons/white/instagram.svg",
  pinterest: "https://img.promoamp.com/icons/white/pinterest.svg",
  reddit: "https://img.promoamp.com/icons/white/reddit.svg",
  whatsapp: "https://img.promoamp.com/icons/white/whatsapp.svg",
  tiktok: "https://img.promoamp.com/icons/white/tiktok.svg",
  telegram: "https://img.promoamp.com/icons/white/telegram.svg",
  linkedin: "https://img.promoamp.com/icons/white/linkedin-nb.svg",
  google: "https://img.promoamp.com/icons/google.svg",
  threads: "https://img.promoamp.com/icons/threads.svg",
  justdial: "https://img.promoamp.com/icons/justdial.png",
  indiamart: "https://img.promoamp.com/icons/indiamart.png",
  trustpilot: "https://img.promoamp.com/icons/white/trustpilot.svg",
  web: "https://img.promoamp.com/icons/white/web.svg",
  coupon: "https://img.promoamp.com/icons/white/coupon.svg",
  blog: "https://img.promoamp.com/icons/white/article.svg",
  share: "https://img.promoamp.com/icons/white/share.svg",
  email: "https://img.promoamp.com/icons/white/email.svg",
  "apple music": "https://img.promoamp.com/icons/white/applemusic.svg",
  spotify: "https://img.promoamp.com/icons/white/spotify.svg",
  x: "https://img.promoamp.com/icons/white/x.svg",
  "promo amp": "https://img.promoamp.com/icons/white/promoamp.svg",
  twitter: "https://img.promoamp.com/icons/white/x.svg",
  youtube: "https://img.promoamp.com/icons/white/youtube.svg",
  "app store": "https://img.promoamp.com/icons/appstore.svg",
  "google play": "https://img.promoamp.com/icons/playstore.svg",
  stripe: "https://img.promoamp.com/icons/stripe.png",
  paypal: "https://img.promoamp.com/icons/paypal.svg",
} as const

const PLATFORM_COLORS: Record<string, string> = {
  twitter: "#1DA1F2", // Twitter blue
  x: "#000000", // X (Twitter) blue
  discord: "#5865F2", // Discord blurple
  youtube: "#FF0000", // YouTube red
  twitch: "#9146FF", // Twitch purple
  google: "#FFFFFF", // Google white
  trustpilot: "#00B67A", // Trustpilot green
  "apple music": "#FA2D48", // Apple Music red
  spotify: "#1ED760", // Spotify green
  whatsapp: "#25D366", // WhatsApp green
  instagram:
    "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
  tiktok: "#000000", // TikTok black
  facebook: "#1877F2", // Facebook blue
  telegram: "#24A1DE", // Telegram blue
  linkedin: "#0A66C2", // LinkedIn blue
  github: "#181717", // GitHub dark
  email: "#EA4335", // Gmail red
  website: "#4285F4", // Generic web blue
  reddit: "#FF4500", // Reddit orange
  pinterest: "#E60023", // Pinterest red
  podcast: "#F5D71F", // Podcast yellow
  "promo amp": "#000000", // Promo Amp black
  "app store": "#ffffff", // Apple white
  "google play": "#ffffff", // Android white
} as const

export function getPlatformIcon(platform: string): string {
  const lowercasePlatform = platform.toLowerCase()
  // Find the first matching platform key
  const matchedPlatform = Object.keys(PLATFORM_ICONS).find((key) =>
    lowercasePlatform.includes(key),
  )

  return `${matchedPlatform ? PLATFORM_ICONS[matchedPlatform] : "https://img.promoamp.com/p-logo.png"}`
}

export function getSocialColor(platform: Platform): string {
  const cleanPlatform = platform.toLowerCase().split("(")[0].trim()
  // For Instagram, return the full gradient. For others, return solid color
  if (cleanPlatform === "instagram") {
    return PLATFORM_COLORS[cleanPlatform]
  }
  // For non-gradient platforms, if we get a gradient string, return a fallback color
  const color = PLATFORM_COLORS[cleanPlatform]
  return (color?.startsWith("linear-gradient") ? "#6B7280" : color) || "#6B7280"
}
